import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
var Preload = function Preload(_ref) {
  var _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$fonts = _ref$static2.fonts,
    fonts = _ref$static2$fonts === void 0 ? [] : _ref$static2$fonts;
  return React.createElement(React.Fragment, null, fonts.map(function (_ref2) {
    var path = _ref2.path,
      ext = _ref2.ext;
    return React.createElement('link', {
      as: 'font',
      crossOrigin: 'anonymous',
      href: "".concat(path, ".").concat(ext),
      key: "preload-".concat(path, ".").concat(ext),
      rel: 'preload',
      type: "font/".concat(ext)
    });
  }));
};
Preload.defaultProps = {
  "static": {
    fonts: []
  }
};
process.env.NODE_ENV !== "production" ? Preload.propTypes = {
  "static": shape({
    fonts: arrayOf(shape({
      ext: string,
      path: string
    }))
  })
} : void 0;
Preload.ssr = true;
export default Preload;